import { UserState } from "@/types";
import { createSlice } from "@reduxjs/toolkit";
import { createUser, fetchUsers, updateUser } from "./userThunks";

// Initial state
const initialState: UserState = {
  users: [],
  loading: false,
  error: '',
  initialized: false
}

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Handle test initialization
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true
        state.error = ''
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false
        state.users = action.payload;
        state.initialized = true;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
        state.initialized = true;
      })
    builder
      .addCase(updateUser.pending, (state) => {
        state.loading = true
        state.error = ''
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.loading = false
        state.users = action.payload;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
    builder
      .addCase(createUser.pending, (state) => {
        state.loading = true
        state.error = ''
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.loading = false
        state.users = action.payload;
      })
      .addCase(createUser.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
});

export default userSlice.reducer
